import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcFavouriteSelected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.708 12.24 28 13.41l-6 5.633L23.416 27 16 23.24 8.584 27 10 19.042 4 13.41l8.292-1.168L16 5z"
    />
  </svg>
);
export default SvgIcFavouriteSelected;
